import { render } from "./NZTermsAndConditionPage.vue?vue&type=template&id=6d8ddd5a&scoped=true&ts=true"
import script from "./NZTermsAndConditionPage.vue?vue&type=script&lang=ts"
export * from "./NZTermsAndConditionPage.vue?vue&type=script&lang=ts"

import "./NZTermsAndConditionPage.vue?vue&type=style&index=0&id=6d8ddd5a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8ddd5a"]])

export default __exports__